<template>
  <div class="form-group">
    <div class="col-md-4 col-sm-4 selector" @click="whatIsShow()">
        <select class="selectpicker form-control" v-model="type" name="type">
            <option>type d'activité ou saison</option>
            <option value="ete">Eté</option>
            <option value="hivers">Hiver</option>
            <option value="experiences">Experiences</option>
        </select>
    </div>
    <div class="col-md-4 col-sm-4 selector">
        <select class="bs-select form-control" name="experience">
          <option>type d'experience</option>
          <option v-for='data in experiences' :value="data.type">{{data.type}}</option>
        </select>
    </div>
    <div class="col-md-4 col-sm-4 selector">
        <select class="bs-select form-control" name="nature">
            <option>type d'encadrement</option>
            <option v-for='data in nature' :value="data.type">{{data.type}}</option>
        </select>
    </div>
    <div class="col-md-12 col-sm-4 selector" v-if="showEte">
        <select class="bs-select form-control" name="ete">
          <option>type d'activité d'été</option>
          <option v-for='data in ete' :value="data.type">{{data.type}}</option>

        </select>
    </div>
    <div class="col-md-12 col-sm-4 selector" v-if="showHivers">
        <select class="bs-select form-control" name="hivers">
          <option>type d'activité d'hiver</option>
          <option v-for='data in hivers' :value="data.type">{{data.type}}</option>

        </select>
    </div>
    <div class="col-md-12 col-sm-4 selector" v-if="all">
        <select class="bs-select form-control" name="etehivers">
          <option>type d'activité d'experience</option>
          <option v-for='data in etehivers' :value="data.type">{{data.type}}</option>
        </select>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      type:'type d\'activité ou saison',
      experiences:[{type:'Sur mesure'}, {type:'Toute saison'}, {type:'Nuit en refuge'}, {type:'Voyage'}, {type:'Séminaire'}],
      nature:[{type:'Encadrant seul'}, {type:'Tout compris'}],
      ete:[{type: 'Randonnée'}, {type:'Canyoning'}, { type: 'Via ferrata'}, { type: 'Escalade'}, { type: 'Alpinisme'}, { type: 'Randonnée glacière'}, { type: 'Spéléologie'}, { type: 'VTT'}, { type: 'Marche nordique'}, { type: 'Parapente'}, ],
      hivers:[{ type: 'Ski de randonnée'}, { type: 'Ski hors piste / freeride'}, { type: 'Ski sur piste'}, { type:'Ski nordique'},{ type: 'Héliski'}, { type:'Raquette'}, { type:'Cascade de glace'}, { type:'Raid à ski'}, { type:'Après ski'}],
      showEte:false,
      showHivers:false,
      etehivers:[{type: 'Randonnée'}, {type:'Canyoning'}, { type: 'Via ferrata'}, { type: 'Escalade'}, { type: 'Alpinisme'}, { type: 'Randonnée glacière'}, { type: 'Spéléologie'}, { type: 'VTT'}, { type: 'Marche nordique'}, { type: 'Parapente'}, { type: 'Ski de randonnée'}, { type: 'Ski hors piste / freeride'}, { type: 'Ski sur piste'}, { type:'Ski nordique'},{ type: 'Héliski'}, { type:'Raquette'}, { type:'Cascade de glace'}, { type:'Raid à ski'}, { type:'Après ski'} , { type:'Fatbike'}, { type: 'Triathlon'}, { type: 'Trail'}, { type: 'Training'}, { type: 'Stage'}, {type: 'Marche nordique'}, {type: 'Préparation athlétique'}],
      all:false
    }
  },
  computed:{
    whatIsShow(){
      if (this.type === 'ete') {
        this.showEte = true,
        this.all = false,
        this.showHivers = false
      }else if (this.type === 'hiver') {
        this.showEte = false,
        this.showHivers = true,
        this.all = false
      }else if (this.type === 'experiences') {
        this.showEte = false,
        this.showHivers = false,
        this.all = true
      }else {
        this.showEte = false,
        this.showHivers = false,
        this.all = false
      }
    }
  }
}
</script>
